module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/ForgedinFire.8ac6a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/ForgedinFire.jpg
// module id = N0zc
// module chunks = 0